import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/Nav";
import { FloatingCTAs } from "@/components/FloatingCTAs";
import { Marquee } from "@/components/Marquee";
import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { Highlights } from "@/components/sections/Highlights";
import { WhyInvest } from "@/components/sections/WhyInvest";
import { Location } from "@/components/sections/Location";
import { SitePlan } from "@/components/sections/SitePlan";
import { UnitSizes } from "@/components/sections/UnitSizes";
import { Pricing } from "@/components/sections/Pricing";
// import { PaymentPlan } from "@/components/sections/PaymentPlan";
// import { ProjectStatus } from "@/components/sections/ProjectStatus";
import { CentralHeightsAbout } from "@/components/sections/CentralHeightsAbout";
import { CentralHeightsShowcase } from "@/components/sections/CentralHeightsShowcase";
import { Gallery } from "@/components/sections/Gallery";
import { WhyBuildaxis } from "@/components/sections/WhyBuildaxis";
import { FAQ } from "@/components/sections/FAQ";
import { ReraDisclosure } from "@/components/sections/ReraDisclosure";
import { LeadForm } from "@/components/sections/LeadForm";
import { TalkToSales } from "@/components/sections/TalkToSales";
import { Footer } from "@/components/sections/Footer";

function App() {
  useLenis();

  return (
    <div className="App">
      <Nav />
      <FloatingCTAs />
      <main>
        <Hero />
        <Marquee text="SECTOR 10A — KHARKHODA — SONIPAT ✦ FIRST PREMIUM SCO COMPLEX ✦ 45M FRONTAGE ROAD ✦ BASEMENT + 4 FLOORS ✦ 16 EXCLUSIVE UNITS ✦" />
        <CentralHeightsAbout />
        <CentralHeightsShowcase />
        <About />
        <Highlights />
        <WhyInvest />
        <Location />
        <SitePlan />
        <UnitSizes />
        <Pricing />
        {/* <PaymentPlan /> */}
        {/* <ProjectStatus /> */}
        <Gallery />
        <WhyBuildaxis />
        <FAQ />
        <ReraDisclosure />
        <LeadForm />
        <TalkToSales />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
